import { ApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Employer } from './employer.interface';
import { EmployerService } from './employer.service';
import EmployerTeamStore, { EmployerTeamState } from './teams/team.store';

const service = new EmployerService();

export interface EmployerState {
   employersOverview?: ApiResource<Array<Employer>>;

   team?: EmployerTeamState;
}

const EmployerStore: Module<EmployerState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_EMPLOYERS(state, overview: ApiResource<Array<Employer>>) {
         state.employersOverview = overview;
      },
      ADD_EMPLOYER(state, employer: Employer) {
         state.employersOverview?.data?.push(employer);
      },
      CHANGE_EMPLOYER(state, employer: Employer) {
         const index = (state.employersOverview?.data || []).findIndex((e) => e.id === employer.id);
         if (index > -1) state.employersOverview?.data.splice(index, 1, employer);
      },
      DELETE_EMPLOYER(state, employerId: number) {
         const index = (state.employersOverview?.data || []).findIndex((e) => e.id === employerId);
         if (index > -1) state.employersOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getEmployers(context, query?: LocationQuery) {
         const response = await service.getEmployers(query);
         context.commit('SET_EMPLOYERS', response);
         return response;
      },
      async searchEmployers(context, query?: LocationQuery) {
         const response = await service.getEmployers(query);
         return response.data;
      },
      async getEmployer(context, employerId: number) {
         return await service.getEmployer(employerId);
      },
      async createEmployer(context, employer: Employer) {
         const newLogo = employer.logo;

         let response = await service.postEmployer({ ...employer, logo: undefined, teams: employer.teams?.map((t) => t.id) as any });

         try {
            if (typeof newLogo === 'object') {
               response = await context.dispatch('changeEmployerLogo', { employerId: response.id, logo: newLogo });
            }
         } catch {
            console.log('Could not upload logo');
         }

         context.commit('ADD_EMPLOYER', response);
         return response;
      },
      async changeEmployer(context, payload: { employerId: number; employer: Employer }) {
         const newLogo = payload.employer.logo;

         let response = await service.putEmployer(payload.employerId, {
            ...payload.employer,
            logo: undefined,
            teams: payload.employer.teams?.map((t) => t.id) as any,
         });
         if (typeof newLogo === 'object') {
            response = await context.dispatch('changeEmployerLogo', { employerId: response.id, logo: newLogo });
         }
         context.commit('CHANGE_EMPLOYER', response);
         return response;
      },
      async deleteEmployer(context, employerId: number) {
         const response = await service.deleteEmployer(employerId);
         context.commit('DELETE_EMPLOYER', response);
         return response;
      },
      async changeEmployerLogo(context, payload: { employerId: number; logo: File }) {
         return service.postEmployerLogo(payload.employerId, payload.logo);
      },
   },
   modules: {
      team: EmployerTeamStore,
   },
};

export default EmployerStore;
